import './Styles/ProductsListStyles.css'

import { useEffect, useState } from 'react'
import Product from './ProductComponents/Product'
import { useShop } from '../../../Providers/ShopProvider'
import useChangePageLastElementRef from '../Hooks/useChangePageLastElementRef'
import SortingDropDown from './SortingDropDown'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import { IoClose } from 'react-icons/io5'
import useHandleCategories from '../Hooks/useHandleCategories'
import { IoListOutline } from "react-icons/io5"
import { TfiViewGrid } from "react-icons/tfi"
import { CgSoftwareDownload } from "react-icons/cg"
import ProductGrid from './ProductComponents/ProductGrid'
import { useCustomer } from '../../../Providers/CustomerProvider'
import { toast } from 'react-toastify'
import InformationErrorModal from '../../../Components/Components/Modals/InformationErrorModal'
import { useAuth } from '../../../Providers/AuthProvider'
import { ConvertPriceToString } from '../../../Helpers/CustomConverter'
import useGetAvailabilityFiltersNames from '../../../Components/HomePage/Hooks/useGetAvailabilityFiltersNames'
import ScrollUpArrow from '../../../Components/Components/ScrollUpArrow'
import { useParams } from '../../../Providers/ParamsProvider'
import { useOffers } from '../../../Providers/OffersProvider'
import YesNoMessageModal from '../../../Components/Components/Modals/YesNoMessageModal'
import { PiSlidersHorizontal } from "react-icons/pi";
import { TbCategory } from "react-icons/tb";
import MobileProductFilters from '../../../Components/MobileComponents/MobileProductFilters'
import MobileProductCategory from '../../../Components/MobileComponents/MobileProductCategory/MobileProductCategory'
import useGetProductsCountForNoCategoryActive from '../../../Components/BasketPage/Hooks/GetProductsCountForNoCategoryActive'
import { IoIosArrowRoundBack } from "react-icons/io";
import useCommonFunctions from '../Hooks/MobileAndDesktopCommon/useCommonFunctions'
import { IoWarningOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { useSavedBaskets } from '../../../Providers/SavedBasketsProvider'
import { useNavigate } from 'react-router-dom'
import useGetParamsFromUrl from '../Hooks/useGetParamsFromUrl'

const ProductsList = () => {
    const params = new URLSearchParams(window.location.search)
    const navigate = useNavigate()
    const { lastBookElementRef } = useChangePageLastElementRef()
    const [tmpProducts, setTmpProducts] = useState([])
    const { handleClearQuery } = useGetParamsFromUrl()
    const [productDisplayMode, setProductDisplayMode] = useState(0) // 0-lista 1-kafelki
    const [productsCount, setProductsCount] = useState(0)
    const [hideDisplayComponent, setHideDisplayComponent] = useState(false)
    const [showExportPriceListInfo, setShowExportPriceListInfo] = useState(false)
    const { handleSendPriceListViaEmail } = useCustomer()
    const { selectedSavedBasket } = useSavedBaskets()

    const { rootCategories, activeCategory, productsFilter, setProductsFilter, categoryData, products, loadingProducts, features, setFeatures, setActiveCategory,
        downloadCategoriesAfterQuerySearching, setDownloadCategoriesAfterQuerySearching, clearProductsFilter } = useShop()

    const { authState } = useAuth()
    const { handleGetCategoriesBySearchingProducts } = useHandleCategories(null, productsFilter, setProductsFilter)
    const [priceListExportMessageText, setPriceListExportMessageText] = useState('')
    const { priceListExportMaxArticle, isMobile } = useParams()
    const { savedOfferId, selectedSavedOffer } = useOffers()
    const [showOfferLabelInfo, setShowOfferLabelInfo] = useState(true)
    const [showMobileCategoryPage, setShowMobileCategoryPage] = useState(false)
    const [showMobileFilterPage, setShowMobileFilterPage] = useState(false)
    const { handleGetProductsCountForNoCategoryActive } = useGetProductsCountForNoCategoryActive()
    const { handleBackToOfferClick, handleBackToSavedBasket } = useCommonFunctions()
    const [showSearchAllCategoryInfo, setShowSearchAllCategoryInfo] = useState(false)
    const [showSavedBasketLabelInfo, setShowSavedBasketLabelInfo] = useState(true)

    useEffect(() => {
        if (authState.user) {
            const email = authState.user.email === '' || authState.user.email === ' ' ? 'Błąd w trakcie generowania cennika, nie zdefiniowano adresu email!' : `Cennik zostanie wysłany na email ${authState.user.email}`
            if (authState.user.email !== '' && authState.user.email !== ' ' && (productsCount > priceListExportMaxArticle)) {
                setPriceListExportMessageText(`${email} . Uwaga zostanie wygenerowane tylko pierwsze ${priceListExportMaxArticle} pozycji! Czy wysłać cennik?`)
            }
            else {
                setPriceListExportMessageText(`${email} ${email.includes('Błąd w trakcie generowania cennika') ? '' : ` Ilość pozycji: ${productsCount}. Czy wysłać cennik?`}`)
            }
        }
    }, [productsCount])

    useEffect(() => {
        if (activeCategory && categoryData && categoryData.currentCategory) {
            setProductsCount(categoryData.currentCategory.artCount)
        }
        else {
            handleCalculateProductsCountForNoActiveCategory()
        }
    }, [rootCategories, categoryData])

    const handleCalculateProductsCountForNoActiveCategory = async () => {
        // let count = 0
        // rootCategories.forEach(c => {
        //     count += c.artCount
        // })
        var productsCount = await handleGetProductsCountForNoCategoryActive()
        setProductsCount(productsCount)
    }

    useEffect(() => {
        var localeStorageDisplayMode = localStorage.getItem('productDisplayMode')
        if (localeStorageDisplayMode) {
            setProductDisplayMode(localeStorageDisplayMode)
        }
    }, [])

    useEffect(() => {
        const distinctProducts = products.filter((product, i, self) =>
            i === self.findIndex(p => p.index === product.index))
        setTmpProducts(distinctProducts)
    }, [products])

    useEffect(() => {
        if (products && products.length > 0 && productsFilter.SearchingQuery) {
            if (downloadCategoriesAfterQuerySearching) {
                handleSetCategoriesBySearchingProducts()
                setDownloadCategoriesAfterQuerySearching(false)
            }
        }
    }, [products])

    useEffect(() => { //DK : Zdejmowanie kategori jeżeli nie znalazł produktu w niej    
        if (productsFilter.SearchingQuery && productsFilter.SearchingQuery.trim() != '' && productsFilter.ActiveCatNodeId != 0 && products.length === 0 && !loadingProducts) {
            setShowSearchAllCategoryInfo(true)
            setProductsFilter(prev => ({
                ...prev,
                ActiveCatNodeId: 0
            }))
            params.delete('cat')
            navigate(`/shop?${params.toString()}`)
        }
    }, [loadingProducts])

    useEffect(() => {
        if (productsFilter.ActiveCatNodeId != 0 || !productsFilter.SearchingQuery || productsFilter.SearchingQuery.trim() == '') {
            setShowSearchAllCategoryInfo(false)
        }
    }, [productsFilter.ActiveCatNodeId, productsFilter.SearchingQuery])

    const handleSetCategoriesBySearchingProducts = async () => {
        const artCatOrSymbolList = products
            .map(product => product.artCatOrSymbol)
        const categories = await handleGetCategoriesBySearchingProducts(artCatOrSymbolList)
        if (categories && categories.length > 0) {
            setActiveCategory(categories) //DK Tutaj tak zostawiamy dla wielu kategori nie dodamy do url cat - tutaj nie da sie zrobić wstecz - sytuacja tylko jak wyszukujesz
        }
    }
    const removeFilter = (name, value) => {
        var featuresList = features.filter(x => x.name !== name)
        var feature = features.find(x => x.name == name)

        var featureValues = feature.values.filter(x => x !== value)

        if (featuresList.length === 0) {
            if (featureValues.length == 0) {
                setFeatures([])
            } else {
                setFeatures([{ "index": "", "name": name, "category": "", "values": featureValues }])
            }

        } else {
            if (featureValues.length == 0) {
                setFeatures(featuresList)
            } else {
                setFeatures([...featuresList, { "index": "", "name": name, "category": "", "values": featureValues }])
            }
        }

    }
    const handleChangeDisplayMode = (mode) => {
        localStorage.setItem("productDisplayMode", parseInt(mode))
        setProductDisplayMode(mode)
    }
    const handleExportPrices = () => {
        setShowExportPriceListInfo(true)
    }
    const handleExportPriceListModalAnswer = async (answer) => {
        if (answer) {
            if (authState.user.email !== '' && authState.user.email !== ' ') {
                if (await handleSendPriceListViaEmail(productsFilter) == false) {
                    toast.error('Błąd przy eksporcie cennika, proszę spróbować później')
                }
            }
        }
        setShowExportPriceListInfo(false)
    }

    const handleResetAllFilters = () => {
        clearProductsFilter(false, true)
    }


    const displayComponentStyle = hideDisplayComponent ? 'hidden' : ''
    const exportPriceStyle = authState.user && authState.user.isOperator && authState.selectedCustomerData ? '' : 'collapse'

    return (
        <>
            <div className='products col '>
                <ScrollUpArrow />
                <MobileProductFilters
                    showMobileFilterPage={showMobileFilterPage}
                    setShowMobileFilterPage={setShowMobileFilterPage}
                />
                <MobileProductCategory
                    showMobileCategoryPage={showMobileCategoryPage}
                    setShowMobileCategoryPage={setShowMobileCategoryPage}
                />
                <div className='row mb-4'>

                    {isMobile && <div className="row mb-2">
                        <div className="col-6 d-flex justify-content-start">
                            <div className='action-button' onClick={() => setShowMobileCategoryPage(true)}>
                                <span className='me-3'>Kategorie</span>
                                <TbCategory size={26} color='var(--primary)' />
                            </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                            <div className='d-flex action-button' onClick={() => setShowMobileFilterPage(true)}>
                                <span className='me-3'>Filtrowanie</span>
                                <PiSlidersHorizontal size={26} color='var(--primary)' />
                            </div>
                        </div>
                    </div>}

                    <div className="col-12 col-md-3">
                        <SortingDropDown />
                    </div>
                    <div className="col-12 mt-2 mb-2 mt-md-0 mb-md-0 col-md-3 d-flex align-items-center">
                        <span>{`Liczba produktów: ${productsCount}`}</span>
                    </div>
                    <div className={`col d-flex align-items-center ${displayComponentStyle}`}>
                        <span>Wyświetlanie</span>
                        <IoListOutline size={31} className='ms-3 element-pointer' color={productDisplayMode == 0 ? 'black' : 'var(--secondary)'} onClick={() => handleChangeDisplayMode(0)} />
                        <TfiViewGrid size={23} className='ms-3 element-pointer' color={productDisplayMode == 1 ? 'black' : 'var(--secondary)'} onClick={() => handleChangeDisplayMode(1)} />
                    </div>
                    <div className={`col d-flex align-items-center justify-content-end ${exportPriceStyle}`}>
                        <span>Eksport cennika</span>
                        <CgSoftwareDownload size={30} className='ms-3 element-pointer' onClick={() => handleExportPrices()} />
                    </div>
                    {savedOfferId != -1 && isMobile &&
                        <div className="row d-flex justify-content-end mt-4">
                            <button className='btn-app-secondary' onClick={() => handleBackToOfferClick(selectedSavedOffer.savedOffer.mode)}>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <IoIosArrowRoundBack className='ms-3 me-3' size={30} color='var(--primary)' />
                                    <span className='ms-3 me-3'>Powrót do oferty</span>
                                </div>
                            </button>
                        </div>
                    }
                    {selectedSavedBasket && isMobile && <div className="row d-flex justify-content-end mt-4">
                        <button className='btn-app-secondary' onClick={handleBackToSavedBasket}>
                            <div className='d-flex align-items-center justify-content-center'>
                                <IoIosArrowRoundBack className='ms-3 me-3' size={30} color='var(--primary)' />
                                <span className='ms-3 me-3'>Powrót do szybkokoszyków</span>
                            </div>
                        </button>
                    </div>}

                </div>
                <div className='row mb-2'>
                    {<FeatureFilterSection
                        features={features}
                        SearchingQuery={productsFilter.SearchingQuery}
                        removeFilter={removeFilter}
                        handleClearQuery={handleClearQuery}
                        productsFilter={productsFilter}
                        setProductsFilter={setProductsFilter}
                        clearProductsFilter={clearProductsFilter}
                    />}
                </div>
                <div className={`row ${savedOfferId != -1 && showOfferLabelInfo ? '' : 'collapse'}`}>
                    <div className="col no-available-products mb-3">
                        <div className="col">
                            <span className='ms-0 ms-xxl-3'>Uwaga! Pracujesz w trybie koszyka oferty / zapytania ofertowego!</span>
                        </div>
                        <div className="col-auto">
                            <IoClose size={25} className='element-pointer' onClick={() => setShowOfferLabelInfo(false)} />
                        </div>
                    </div>
                </div>
                <div className={`row ${selectedSavedBasket && showSavedBasketLabelInfo ? '' : 'collapse'}`}>
                    <div className="col no-available-products mb-3">
                        <div className="col">
                            <span className='ms-0 ms-xxl-3'>Uwaga! Pracujesz w trybie dodawania pozycji do szybkokoszyka!</span>
                        </div>
                        <div className="col-auto">
                            <IoClose size={25} className='element-pointer' onClick={() => setShowSavedBasketLabelInfo(false)} />
                        </div>
                    </div>
                </div>
                <GenerateProducts
                    products={tmpProducts}
                    productDisplayMode={productDisplayMode}
                    lastBookElementRef={lastBookElementRef}
                    loadingProducts={loadingProducts}
                    isMobile={isMobile}
                    handleResetAllFilters={handleResetAllFilters}
                    productsFilter={productsFilter}
                    showSearchAllCategoryInfo={showSearchAllCategoryInfo}
                    setShowSearchAllCategoryInfo={setShowSearchAllCategoryInfo}
                />

                {(loadingProducts) && <div className='products-zero col-12 col-md-12 col-lg-7 col-xl-12'>
                    <LoadingSpinner />
                </div>}
            </div>
            {priceListExportMessageText.includes('Błąd w trakcie generowania') ? (<InformationErrorModal
                show={showExportPriceListInfo}
                setShow={setShowExportPriceListInfo}
                title={'Eksport cennika'}
                message={priceListExportMessageText}
                isError={true}
            />) : (<YesNoMessageModal
                show={showExportPriceListInfo}
                onHide={handleExportPriceListModalAnswer}
                title={'Eksport cennika'}
                message={priceListExportMessageText}
                showCloseButton={false}
            />)}
        </>
    )
}

const GenerateProducts = ({ products, productDisplayMode, lastBookElementRef, loadingProducts, isMobile, handleResetAllFilters, productsFilter, showSearchAllCategoryInfo,
    setShowSearchAllCategoryInfo
}) => {

    const isAnyFilterActive = (productsFilter.ProductsFeatures && productsFilter.ProductsFeatures.length > 0) || productsFilter.ProductsFeatures != 0 ||
        productsFilter.IsNew || productsFilter.IsPromo || productsFilter.IsSellOut || productsFilter.PriceFrom != 0 || productsFilter.PriceTo != 0 || (productsFilter.SearchingQuery && productsFilter.SearchingQuery.trim() != '') ||
        (productsFilter.AvailabilityFilters.OnlyLocal || productsFilter.AvailabilityFilters.OnlyRegional || productsFilter.AvailabilityFilters.OnlyMacroRegional)


    if (!isAnyFilterActive && products.length === 0 && !loadingProducts) {
        return <div className='col justify-content-center'>Brak produktów</div>
    }
    if (products.length === 0 && !loadingProducts && isAnyFilterActive) {
        return (<div className='d-flex flex-column justify-content-start'>
            <span className='error-text-color'>Nie znaleziono produktów z założonymi filtrami.</span>
            <button className='btn-app-secondary mt-4 col-12 col-md-6 col-xl-4' onClick={() => handleResetAllFilters()}>Wyczyść filtry i cofnij kategorie</button>
        </div>)
    }
    if (productDisplayMode == 0) {
        return (
            <>
                {showSearchAllCategoryInfo && <div className='no-products-in-category-holder mb-3'>
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <IoWarningOutline size={40} color='#fac314' />
                        </div>
                        <div className="col">
                            <span>W wybranej kategorii nie było tego, czego szukasz. Poszukaliśmy więc po wszystkich kategoriach.</span>
                        </div>
                        <div className="col-auto element-pointer">
                            <IoMdClose size={35} onClick={() => setShowSearchAllCategoryInfo(false)} />
                        </div>
                    </div>
                </div>}

                <div className='row align-items-center '>
                    {products && products.map((product, index) => {
                        if (products.length === index + 1) {
                            return <div className='col-12' ref={lastBookElementRef}>
                                <Product
                                    key={product.index}
                                    product={product}
                                    isBasketSummary={false}
                                    additionalOptions={null}
                                />
                            </div>
                        }
                        return <div className='col-12'>
                            <Product
                                key={product.index}
                                product={product}
                                isBasketSummary={false}
                                additionalOptions={null}
                            />
                        </div>
                    })}
                </div>
            </>
        )
    }
    else {
        return (
            <>
                {showSearchAllCategoryInfo && <div className='no-products-in-category-holder mb-3'>
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <IoWarningOutline size={40} color='#fac314' />
                        </div>
                        <div className="col">
                            <span>W wybranej kategorii nie było tego, czego szukasz. Poszukaliśmy więc po wszystkich kategoriach.</span>
                        </div>
                        <div className="col-auto element-pointer">
                            <IoMdClose size={35} onClick={() => setShowSearchAllCategoryInfo(false)} />
                        </div>
                    </div>
                </div>}

                <div className='row align-items-center '>
                    {products && products.map((product, index) => {
                        if (products.length === index + 1)
                            return <div className='col-12 col-md-6 col-lg-4 col-xl-3' ref={lastBookElementRef}>
                                <ProductGrid
                                    key={index}
                                    product={product}
                                />
                            </div>

                        return <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                            <ProductGrid
                                key={index}
                                product={product}
                            />
                        </div>
                    })}
                </div>
            </>
        )
    }
}

const FeatureFilterSection = ({ features, SearchingQuery, removeFilter, handleClearQuery, productsFilter, setProductsFilter, clearProductsFilter }) => {
    const { showFeatureListFilter } = useShop()
    const { availabilityFiltersNames } = useGetAvailabilityFiltersNames()

    const showClearButton = productsFilter.AvailabilityFilters.OnlyLocal || productsFilter.AvailabilityFilters.OnlyRegional || productsFilter.AvailabilityFilters.OnlyMacroRegional ||
        SearchingQuery || productsFilter.Suppliers.length > 0 || productsFilter.PriceFrom !== 0 || productsFilter.PriceTo !== 0 || productsFilter.IsPromo || productsFilter.IsSellOut ||
        productsFilter.IsNew || productsFilter.AllArticles || features.length > 0

    return (<>
        {showFeatureListFilter && features && features && features.length > 0 && features.map(feature =>
            feature.values.map(value => (
                <div className='col-auto feature-item' key={value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()}>
                    <div className='row align-items-center'>
                        <div className='col-auto feature-item-remove-icon' onClick={() => removeFilter(feature.name, value)}>
                            <IoClose />
                        </div>
                        <div className='col'>{value}</div>
                    </div>
                </div>
            ))
        )}

        {SearchingQuery && <div className='col-auto feature-item'>
            <div className='row align-items-center'>
                <div className='col-auto feature-item-remove-icon' onClick={() => { handleClearQuery() }}>
                    <IoClose />
                </div>
                <div className='col'>{SearchingQuery.charAt(0).toUpperCase() + SearchingQuery.slice(1).toLowerCase()}</div>
            </div>
        </div>}

        {productsFilter.Suppliers.length > 0 && productsFilter.Suppliers.map((item, key) => (
            <div className='col-auto feature-item' key={key}>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            Suppliers: prev.Suppliers.filter(x => x.supplierId !== item.supplierId)
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{item.supplierName.charAt(0).toUpperCase() + item.supplierName.slice(1).toLowerCase()}</div>
                </div>
            </div>
        ))}

        {(productsFilter.PriceFrom !== 0 || productsFilter.PriceTo !== 0) &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            PriceFrom: 0,
                            PriceTo: 0,
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{`Cena od ${ConvertPriceToString(productsFilter.PriceFrom)} Do ${ConvertPriceToString(productsFilter.PriceTo)}`}</div>
                </div>
            </div>}

        {availabilityFiltersNames.length > 0 && productsFilter.AvailabilityFilters.OnlyLocal &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            AvailabilityFilters: {
                                ...prev.AvailabilityFilters,
                                OnlyLocal: false
                            }
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{availabilityFiltersNames[0]}</div>
                </div>
            </div>}

        {availabilityFiltersNames.length > 0 && productsFilter.AvailabilityFilters.OnlyRegional &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            AvailabilityFilters: {
                                ...prev.AvailabilityFilters,
                                OnlyRegional: false
                            }
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{availabilityFiltersNames[1]}</div>
                </div>
            </div>}

        {availabilityFiltersNames.length > 0 && productsFilter.AvailabilityFilters.OnlyMacroRegional &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            AvailabilityFilters: {
                                ...prev.AvailabilityFilters,
                                OnlyMacroRegional: false
                            }
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{availabilityFiltersNames[2]}</div>
                </div>
            </div>}

        {availabilityFiltersNames.length > 0 && productsFilter.AvailabilityFilters.OnlySupplier &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            AvailabilityFilters: {
                                ...prev.AvailabilityFilters,
                                OnlySupplier: false
                            }
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{availabilityFiltersNames[3]}</div>
                </div>
            </div>}

        {productsFilter.IsPromo &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            IsPromo: false
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{'Promocja'}</div>
                </div>
            </div>}

        {productsFilter.IsSellOut &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            IsSellOut: false
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{'Wyprzedaż'}</div>
                </div>
            </div>}

        {productsFilter.IsNew &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            IsNew: false
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{'Nowość'}</div>
                </div>
            </div>}

        {productsFilter.AllArticles &&
            <div className='col-auto feature-item'>
                <div className='row align-items-center'>
                    <div className='col-auto feature-item-remove-icon' onClick={() => {
                        setProductsFilter(prev => ({
                            ...prev,
                            AllArticles: false
                        }))
                    }}>
                        <IoClose />
                    </div>
                    <div className='col'>{'Baza produktów na zamówienie'}</div>
                </div>
            </div>}

        {showClearButton &&
            <div className='col-auto feature-item' style={{ border: '0', backgroundColor: 'transparent' }}>
                <div className='row align-items-center element-pointer' onClick={() => { clearProductsFilter(true, true) }} >
                    <div className='col-1 feature-item-remove-icon'>
                        <IoClose />
                    </div>
                    <div className='col'>{'Usuń wszystkie filtry'}</div>
                </div>
            </div>
        }
    </>)
}

export default ProductsList
